/**
 * News Posts JS
 */

// CSS
const $ = window.jQuery;
let title = $(".content h1:contains('[field title]')");
let date = $(".content p:contains('[field date]')");
let dateAuthor = $(".content p:contains('[field date] | [field author]')");

if (title.length > 0) {
  title.remove();
}

if (date.length > 0) {
  date.remove();
}

if (dateAuthor.length > 0) {
  dateAuthor.remove();
}
